import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';
import { JobLogsTableSkeletonComponent } from '../job-logs-table-skeleton/job-logs-table-skeleton.component';

@Component({
  selector: 'app-job-logs-skeleton',
  templateUrl: './job-logs-skeleton.component.html',
  styleUrls: ['./job-logs-skeleton.component.scss'],
  imports: [SkeletonComponent, JobLogsTableSkeletonComponent],
})
export class JobLogsSkeletonComponent {
  readonly summaryStats = [1, 2, 3, 4, 5, 6, 7, 8];
}